import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { plantInfo, itemParam, ListParams } from 'models';

export interface PlantState {
  loading: boolean;
  currentPlant?: plantInfo;
  error?: string;
  plantList: plantInfo[];
}

const initialState: PlantState = {
  loading: false,
  currentPlant: undefined,
  error: undefined,
  plantList: [],
};

const plantSlice = createSlice({
  name: 'plant',
  initialState,
  reducers: {
    fetchPlantInfo(state, action: PayloadAction<itemParam>) {
      state.loading = true;
    },
    fetchPlantInfoSuccess(state, action: PayloadAction<plantInfo>) {
      state.loading = false;
      state.currentPlant = action.payload;
    },
    fetchPlantInfoFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    deletePlantById(state, action: PayloadAction<string>) {
      state.loading = true;
    },
    fetchPlantList(state, action: PayloadAction<ListParams>) {
      state.loading = true;
    },
    fetchPlantListSuccess(state, action: PayloadAction<plantInfo[]>) {
      state.loading = false;
      state.plantList = action.payload;
    },
    fetchPlantListFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const plantActions = plantSlice.actions;

export const selectPlantError = (state: RootState) => state.plantReducer.error;
export const selectLoading = (state: RootState) => state.plantReducer.loading;
export const selectPlantInfo = (state: RootState) => state.plantReducer.currentPlant;
export const selectPlantList = (state: RootState) => state.plantReducer.plantList;

const plantReducer = plantSlice.reducer;
export default plantReducer;
